import { ChangeEvent } from 'react';
import { FormikValues } from 'formik';

import { StackProps, VStack } from '@chakra-ui/react';

import { TextField } from 'ui';

interface AddGiftCardFormProps extends StackProps {
  bg: string;
  color: string;
  formData: FormikValues;
  isCentered?: boolean;
}

const AddGiftCardForm = ({
  bg,
  color,
  formData,
  isCentered = false,
  ...props
}: AddGiftCardFormProps) => {
  const { getFieldProps, setFieldValue, errors, touched, values } = formData;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name, value }
    } = e;

    setFieldValue(name, value);
  };

  const resetFieldHandler = (field: string) => () => setFieldValue(field, '');

  return (
    <VStack
      bg={bg}
      borderRadius='6px'
      w='full'
      h='197px'
      justifyContent='center'
      alignItems='flex-start'
      {...props}
    >
      <TextField
        autoFocus
        {...getFieldProps('cardNumber')}
        labelStyles={{
          fontSize: { base: '13px', md: '15px' },
          color
        }}
        fontSize={{ base: '40px', md: '60px' }}
        type='number'
        h='117px'
        label='GIFT CARD NUMBER'
        error={errors.cardNumber}
        touched={!!touched.cardNumber}
        onReset={resetFieldHandler('cardNumber')}
        isFieldValue={!!values.cardNumber}
        onChange={handleInputChange}
        containerStyles={{
          marginBottom: '15px'
        }}
        inputStyles={{
          textAlign: isCentered ? 'center' : 'left'
        }}
      />
    </VStack>
  );
};

export default AddGiftCardForm;
